
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img 
              src="https://static.readdy.ai/image/f38dbee0b97d493b71475a98132a7b29/fe575dafebbccf1474ba15623f412b74.png"
              alt="TheSpire Logo"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Transforming Africa through technology, creativity, and education.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#6D03F4]">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/courses" className="text-gray-400 hover:text-white transition-colors">Courses</Link></li>
              <li><Link to="/software" className="text-gray-400 hover:text-white transition-colors">Software</Link></li>
              <li><Link to="/daas" className="text-gray-400 hover:text-white transition-colors">DaaS</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#6D03F4]">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/events" className="text-gray-400 hover:text-white transition-colors">Events</Link></li>
              <li><Link to="/alert" className="text-gray-400 hover:text-white transition-colors">Alert</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#6D03F4]">Contact</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 flex-shrink-0"></i>
                <span>Wuse 2, Abuja, FCT, Nigeria</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 flex-shrink-0"></i>
                <a href="tel:+2349167710173" className="hover:text-white transition-colors">+234 916 771 0173</a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2 flex-shrink-0"></i>
                <a href="mailto:info@thespire.com.ng" className="hover:text-white transition-colors">info@thespire.com.ng</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 sm:mb-0">
            © {new Date().getFullYear()} TheSpire. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a 
              href="https://wa.me/2349167710173" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
          </div>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition-colors text-sm mt-4 sm:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
